<template>
  <div class="BusinessProcesses">
    <div class="main">
      <p class="title">道泰大数据业务流程</p>

      <img class="imgProcess" :src="imgProcess" />

      <!-- <div class="AnalysisModel">
        <img class="imgAnalysis1" :src="imgAnalysis1" />
        <img class="imgAnalysis2" :src="imgAnalysis2" />

        <p class="text1">我们已经具有海量数据的分析能力，并在信用卡用户的精准分析上积累了丰富的经验</p>
        <p class="text2">同样各家金融机构将面临数据资产化的要求，我们具备在大数据应用层面的合作能力</p>

      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'BusinessProcesses',
  data () {
    return {
      img1: require("@/assets/imgs/img-tec-model-00.png"),
      imgAnalysis1: require("@/assets/imgs/img-Analysis1.png"),
      imgAnalysis2: require("@/assets/imgs/img-Analysis2.png"),
      imgProcess: require("@/assets/imgs/img-process.png"),
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  .BusinessProcesses {
    padding-bottom: 40px;

    .main {
      width: 1200px;
      margin: 0 auto;

      p {
        margin: 0;
        text-align: center;
      }
      >.title {
        font-size:48px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        padding: 40px 0 29px;
      }

      .imgProcess {
        width: 545px;
        display: block;
        margin: 20px auto 64px;
      }
      .AnalysisModel {
        width: 1000px;
        height: 553px;
        margin: 0 auto;
        position: relative;
        border: 1px dotted #ccc;
        border-radius: 3px;

        .imgAnalysis1 {
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          top: 2%;
        }
        .imgAnalysis2 {
          position: absolute;
          left: 50%;
          top: 12%;
          transform: translate(-50%, 0);
        }

        p {
          font-size:20px;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:rgba(0,0,0,1);
          line-height:48px;
          position: absolute;
          left: 50%;
          transform: translate(-50%,0);
          text-align: center;
          width: 100%;
          &.text1 {
            bottom: 75px;
          }
          &.text2 {
            bottom: 35px;
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Technology_Services/BusinessProcesses.vue